import {styled} from "@mui/material/styles";
import {Box} from "@mui/material";

export const WrapperBox = styled(Box)(({theme}) => ({
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.themeColors.grey['40']}`,
  background: theme.palette.common.white,
}));